import { Navigate, Outlet } from "react-router-dom";
import { useAuthSession } from "src/hooks/useAuthSession";
import { RouteEnvironmentProviders } from "src/routing/components/RouteEnvironment";

/** Auth gate for guest-only pages (`/signIn`, `/auth/gcallback`).
 *
 * Role: data router root `Component` on the auth domain `RouteObject`.
 * Inverse of `AppShell`: renders `<Outlet/>` when unauthenticated, otherwise redirects to `/`.
 *
 * Does not call `useDeepLink` — `AppShell` saves the pre-login URL; the `/` index consumes it.
 */
export function GuestShell() {
  const { isAuthenticating, isAuthenticated } = useAuthSession();

  if (isAuthenticating) {
    return <div />;
  }

  return (
    <RouteEnvironmentProviders>{isAuthenticated ? <Navigate to="/" replace /> : <Outlet />}</RouteEnvironmentProviders>
  );
}
